import type { ReactNode } from 'react';

type Tone = 'info' | 'warning' | 'neutral';

const TONES: Record<Tone, { bg: string; color: string }> = {
  info: { bg: 'rgba(0,91,150,0.09)', color: 'var(--cta-default)' },
  warning: { bg: 'var(--warning-bg)', color: 'var(--warning-text)' },
  neutral: { bg: 'var(--surface-tint)', color: 'var(--text-secondary)' },
};

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  const t = TONES[tone];
  return (
    <span style={{ background: t.bg, color: t.color, fontSize: 11.5, fontWeight: 700, padding: '4px 10px', borderRadius: 999, whiteSpace: 'nowrap' }}>
      {children}
    </span>
  );
}
